import { BRIDGE_ERROR_CODES, BridgeError, ROUTES } from '@kinoq/camera-protocol';
import { shellApi } from './desktopDiscovery';

function bridgeError(status: number, body: string): BridgeError {
  try {
    const wire: unknown = JSON.parse(body);
    if (typeof wire === 'object' && wire !== null) {
      const { code, message } = wire as Record<string, unknown>;
      const known = BRIDGE_ERROR_CODES.find((c) => c === code);
      if (known && typeof message === 'string') return new BridgeError(known, message);
    }
  } catch {}
  return new BridgeError('BridgeFailed', `the bridge answered HTTP ${status}`);
}

/**
 * Sets one camera property through the shell, since a PUT body cannot go through
 * `bridgeUrl`. The tablet rejects an unknown or unreachable bridge and the desktop
 * resolves its 404 or 502, so both a rejection and a non-2xx status are failures.
 */
export async function setBridgeProperty(
  id: string,
  cameraId: string,
  name: string,
  value: unknown,
): Promise<void> {
  const bridges = shellApi()?.bridges;
  if (!bridges)
    throw new BridgeError('BridgeFailed', 'bridge settings need the tablet or desktop app');
  const { status, body } = await bridges.bridgeRequest({
    id,
    method: 'PUT',
    path: ROUTES.properties(cameraId),
    body: JSON.stringify({ name, value }),
  });
  if (status < 200 || status >= 300) throw bridgeError(status, body);
}
